import {
  type PowerSyncTokenResponse,
  PowerSyncTokenResponseSchema,
} from "@vidimo/shared/contracts";
import { apiJson } from "@/lib/api-request";

export function getPowerSyncToken(): Promise<PowerSyncTokenResponse> {
  return apiJson("/powersync/token", {
    label: "Get PowerSync token",
    method: "GET",
    schema: PowerSyncTokenResponseSchema,
  });
}
